import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { DragDropContext } from 'react-beautiful-dnd';

import { connect } from 'react-redux';
import withStyles from 'react-jss';
import { Translation } from 'react-i18next';
import { get, set, compact } from 'lodash';
import {
  getOnboardingState,
  getTenantState,
  getEcapState,
} from '../../../../../store/selectors';

import {
  getRequiredClassesByAcadPlan,
  getSubjectObj,
  getRequiredClassesBySubjectYearSlot,
  getDestinationIndex,
} from '../dragDropUtil';
import {
  setEcap,
  saveEcap,
  setEcapClassesMatched,
} from '../../../../../store/actions';
import { middle } from '../../../../../copy/ecap/classesSetupCopy.json';
import { coreSubjectsEn } from '../../../../../copy/ecap/classesSetupStrings';

import CoreSubjectsColumn from '../CoreSubjectsColumn';
import ColumnTitlesMobile from './ColumnTitlesMobile';
import AddRow from '../AddRow';
import ClearAll from '../ClearAll';
import Loading from '../../../../utility/Loading';
import ClassSlotMobile from './ClassSlotMobile';
import ClassListColumnMobile from './ClassListColumnMobile';
import CustomClassMobile from './CustomClassMobile';
import XIcon from '../../../../utility/XIcon';

class ClassesDragAndDropMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: 0,
      searchMode: false,
      subjectSearching: '',
    };
    this.mobileClassListX = React.createRef();
  }

  get listOfClasses() {
    return this.props.allClasses;
  }

  get acadPlan() {
    return this.props.currentDegree.acadPlan;
  }

  get currentDegreeRequiredClasses() {
    return getRequiredClassesByAcadPlan(
      this.props.currentDegree.acadPlan,
      this.props.acadPlanClasses
    );
  }

  changeYear = (year) => {
    this.setState({
      year,
    });
  };

  toggleSearch = (bool, subject, classIndex) => {
    this.setState(
      {
        subjectSearching: subject,
        classIndexToReplace: classIndex,
      },
      () => {
        if (bool !== this.state.searchMode) {
          this.props.updateMobileSearchMode(bool);
          this.setState(
            {
              searchMode: bool,
            },
            () => {
              if (bool) return this.mobileClassListX?.current?.focus();
            }
          );
        }
      }
    );
  };

  showSearch = (columnInd) => {
    return (
      <Translation>
        {(t) => (
          <div className="class-search-overlay-mobile">
            <div className="class-list-custom-class-container mobile">
              <div className="top-bar">
                <div
                  role="button"
                  tabIndex={0}
                  className="close-container"
                  onClick={() => {
                    this.toggleSearch(false, '');
                  }}
                  onKeyDown={(e) => {
                    if (['Enter'].includes(e.key)) this.toggleSearch(false, '');
                  }}
                  ref={this.mobileClassListX}
                >
                  <XIcon
                    color={this.props.tenant.primary}
                    scrollIntoView
                    propsClassName="mobile-class-list-x-icon"
                  />
                </div>
              </div>
              <DragDropContext
                onDragEnd={this.onDragEnd}
                onDragStart={this.onDragStart}
              >
                <ClassListColumnMobile
                  id="classes-drag-drop-column"
                  columnInd={columnInd}
                  searchUpdateClassList={this.props.searchUpdateClassList}
                  key="classes-drag-drop-column"
                  addClass={this.onDragEnd}
                  yearIsExpanded
                  subjectSearching={this.state.subjectSearching}
                  filteredClassListsForSearch={
                    this.props.filteredClassListsForSearch
                  }
                  onboarding={this.props.onboarding}
                  tenant={this.props.tenant}
                  allClasses={this.props.allClasses}
                  placedClasses={this.props.placedClasses}
                />
                <CustomClassMobile
                  inputText={t('Class Name')}
                  addClass={this.onDragEnd}
                  tenant={this.props.tenant}
                  columnInd={columnInd}
                  subjectSearching={this.state.subjectSearching}
                  acadPlan={this.props.currentDegree.acadPlan}
                />
              </DragDropContext>
            </div>
          </div>
        )}
      </Translation>
    );
  };

  handleClearAllSelected = async () => {
    const plan = JSON.parse(JSON.stringify(this.props.ecap.plan));

    const newClassesMatchedObj = getSubjectObj().subjectSlotsObj;

    set(plan, 'classes_matched', newClassesMatchedObj);

    this.props.setEcap(plan);
    this.props.saveEcap(this.props.auth.jwtToken, plan);
  };

  handleSingleReqClass = (plan, arrKey, arrIndex, arrVal) => {
    set(plan, `classes_matched.${arrKey}[${arrIndex}]`, arrVal);
    this.props.setEcap(plan.classes_matched);

    if (plan.classes_matched[arrKey][arrIndex] === null) {
      // Remove any null values from a slot that only has 1 required class
      const compactedArray = compact(plan.classes_matched[arrKey]);

      return set(plan, `classes_matched.${arrKey}`, compactedArray);
    }
  };

  handleMultiReqClasses = (plan, arrKey, arrIndex, arrVal, requiredClasses) => {
    // Make sure the array for this subject/year has all the null values needed after this placement
    if (plan.classes_matched[arrKey].length < 1) {
      set(plan, `classes_matched.${arrKey}[${arrIndex}]`, arrVal);

      // Set everything after to null
      if (arrIndex === 0) {
        const goUntilIndex = requiredClasses.length - arrIndex;

        for (let i = arrIndex + 1; i < goUntilIndex; i++) {
          set(plan, `classes_matched.${arrKey}[${i}]`, null);
        }
      }
      // Set everything before to null
      else if (arrIndex > 0) {
        const firstNullIndex = plan.classes_matched[arrKey].findIndex(
          (placedClass) => !placedClass
        );

        for (let i = firstNullIndex; i < arrIndex; i++) {
          set(plan, `classes_matched.${arrKey}[${i}]`, null);
        }
      }
    } else if (plan.classes_matched[arrKey].length >= 1) {
      set(plan, `classes_matched.${arrKey}[${arrIndex}]`, arrVal);
    }
  };

  updateEcap = (arrKey, arrIndex, arrVal) => {
    const plan = JSON.parse(JSON.stringify(this.props.ecap.plan));

    const { subjectIndex, yearIndex } = this.getSubjectYearInfo(arrKey);

    const requiredClasses = this.requiredClassesBySubjectYearSlot(
      subjectIndex,
      yearIndex
    );

    // If not multiple req and that slot has a null value, get rid of it
    if (requiredClasses.length <= 1) {
      this.handleSingleReqClass(plan, arrKey, arrIndex, arrVal);
    }

    if (requiredClasses.length > 1) {
      this.handleMultiReqClasses(
        plan,
        arrKey,
        arrIndex,
        arrVal,
        requiredClasses
      );
    }

    this.props.setEcap(plan);
    this.props.saveEcap(this.props.auth.jwtToken, plan);
  };

  getSubjectSubString = (destinationId) => destinationId.split('_');

  getSubjectYearInfo = (destinationId) => {
    const subjectSubString = this.getSubjectSubString(destinationId);
    const subjectIndex =
      Object.values(coreSubjectsEn).indexOf(subjectSubString[0]) + 1;
    const yearIndex = parseInt(subjectSubString[1], 10) + 1;

    return {
      subjectSubString,
      subjectIndex,
      yearIndex,
    };
  };

  requiredClassesBySubjectYearSlot = (subjectIndex, yearIndex) =>
    getRequiredClassesBySubjectYearSlot(
      subjectIndex,
      yearIndex,
      this.acadPlan,
      this.props.acadPlanClasses
    );

  getSelectedClassObj = (classTitle) => {
    let selectedClass;

    this.listOfClasses.forEach((eachClass) => {
      if (
        eachClass.titleEn === classTitle ||
        eachClass.requirement_title === classTitle
      ) {
        selectedClass = eachClass;
      }
    });

    return selectedClass;
  };

  checkSlot = (subjectSlotId) => {
    if (this.props.placedClasses)
      return this.props.placedClasses[subjectSlotId];
  };

  onDragEnd = (result) => {
    const selectedClass = result.course ? result.course : null;

    if (selectedClass) {
      this.setState({ searchMode: false });
      this.props.updateMobileSearchMode(false);
    }

    const sourceId = get(result, 'source.droppableId');
    const destinationId = get(result, 'destination.droppableId');

    if (!destinationId || sourceId === destinationId) return;

    // DEV NOTE: Figure out out if item should be dropped at index 0 or index 1 here

    const destinationIndex = getDestinationIndex(
      destinationId,
      this.props.placedClasses,
      this.state.classIndexToReplace
    );

    this.updateEcap(destinationId, destinationIndex, selectedClass);
    return document.getElementById('add-class-button-mobile')?.focus();
  };

  get combinedCoreSubjectsList() {
    return this.props.coreSubjectsListEn.map((subjectEn, index) => {
      return {
        english: subjectEn,
        translated: this.props.coreSubjectsList[index],
      };
    });
  }

  getColumn = (index) => {
    return (
      <Translation>
        {(t) => (
          <div
            className="column-footer-container mobile classes-drag-drop-column"
            key={index}
            aria-label={t(
              'Click the Plus Icon to add classes from the class list to your yearly plan. You can add up to two classes per field. If you don’t see an offered course, you can add a new one using the Custom Class option.'
            )}
          >
            <div className="year-column-container" key={index}>
              {this.combinedCoreSubjectsList.map((subjectInfo, rowIndex) => {
                return (
                  <ClassSlotMobile
                    key={subjectInfo.english}
                    disabled={this.props.ecapNotAllowed}
                    subjectEn={subjectInfo.english}
                    subject={subjectInfo.translated}
                    rowIndex={rowIndex}
                    index={index}
                    currentDegree={this.props.currentDegree}
                    currentDegreeReq={this.currentDegreeRequiredClasses}
                    showPlan={this.props.showPlan}
                    tenant={this.props.tenant}
                    toggleSearch={this.toggleSearch}
                    removeClass={this.updateEcap}
                    editCustomClass={this.updateEcap}
                    acadPlanClasses={this.props.acadPlanClasses}
                    placedClassesProp={this.props.placedClasses}
                  />
                );
              })}
            </div>
          </div>
        )}
      </Translation>
    );
  };

  get hasLoaded() {
    return (
      this.props.acadPlanReqClasses &&
      this.props.currentDegree &&
      this.props.placedClasses &&
      Object.keys(this.props.placedClasses).length !== 0
    );
  }

  render() {
    return this.hasLoaded ? (
      <div id="classes-drag-drop-container">
        <div className="classes-core-year-list-columns-container">
          <ColumnTitlesMobile
            year={this.state.year}
            changeYear={this.changeYear}
            tenant={this.props.tenant}
          />
          <div className="classes-core-year-columns-container">
            <CoreSubjectsColumn
              tenant={this.props.tenant}
              coreSubjectsList={this.props.coreSubjectsList}
              coreSubjectsListEn={this.props.coreSubjectsListEn}
              modalImage={this.props.currentDegree.career_image}
              acadPlanClasses={
                this.props.acadPlanReqClasses[this.props.currentDegree.acadPlan]
              }
              placedClasses={this.props.placedClasses}
              ecapPlan={this.props.ecap.plan}
              currentDegree={this.props.currentDegree}
              subjectYearSlots={this.props.placedClasses}
              acadPlanReqClasses={this.props.acadPlanReqClasses}
              mobile
              progressByDegree={this.props.progressByDegree}
            />
            {this.getColumn(this.state.year)}
            {this.state.searchMode ? this.showSearch(this.state.year) : null}
          </div>
        </div>
        <div className="add-row-clear-all-container">
          <AddRow
            color={this.props.tenant.primary}
            handleAddRowSelected={this.props.addElectivesRow}
            electivesRowAdded={Object.keys(this.props.placedClasses).includes(
              'Additional Electives_0'
            )}
          />
          <ClearAll
            color={this.props.tenant.primary}
            handleClearAllSelected={this.handleClearAllSelected}
          />
        </div>
      </div>
    ) : (
      <Loading height="100vh" />
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = getOnboardingState(state);
  const tenant = getTenantState(state);
  const ecap = getEcapState(state);

  return { onboarding, tenant, ecap };
};

export default withRouter(
  connect(mapStateToProps, { setEcap, saveEcap, setEcapClassesMatched })(
    withStyles()(ClassesDragAndDropMobile)
  )
);
